/* ==========================================================================
   Alfa Facet — warstwa interakcji
   Zasady: progressive enhancement, zero zależności, ładowanie z `defer`.
   Bez JS działa: nawigacja, przeglądanie, filtrowanie (submit formularza),
   dodanie do koszyka (natywny submit), akordeony (panele otwarte).
   ========================================================================== */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  /* ---------- narzędzia ------------------------------------------------ */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  function trapFocus(container, onEscape) {
    function handle(e) {
      if (e.key === 'Escape') { e.preventDefault(); onEscape(); return; }
      if (e.key !== 'Tab') return;
      var items = $$(FOCUSABLE, container).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handle);
    return function () { container.removeEventListener('keydown', handle); };
  }

  function announce(message, tone) {
    var live = $('#af-live-region');
    if (live) live.textContent = message;
    var host = $('#af-toast-host');
    if (!host) return;
    host.innerHTML =
      '<div class="af-toast"><div class="af-msg af-msg--' + (tone || 'success') + '" role="status">' +
      '<span>' + message + '</span></div></div>';
    window.clearTimeout(host._t);
    host._t = window.setTimeout(function () { host.innerHTML = ''; }, 5000);
  }
  window.afAnnounce = announce;

  function fmtMoney(cents) {
    var format = (window.AlfaTheme && window.AlfaTheme.moneyFormat) || '{{amount}} zł';
    var value = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return format.replace(/\{\{\s*amount\s*\}\}/, value);
  }
  window.afMoney = fmtMoney;

  /* ---------- Drawer (menu, koszyk, filtry) ---------------------------- */
  var openDrawer = null;
  var releaseTrap = null;
  var lastTrigger = null;

  function closeDrawer() {
    if (!openDrawer) return;
    openDrawer.setAttribute('data-open', 'false');
    openDrawer.setAttribute('aria-hidden', 'true');
    var overlay = $('[data-af-overlay]');
    if (overlay) overlay.setAttribute('data-open', 'false');
    document.body.classList.remove('af-no-scroll');
    $$('[aria-controls="' + openDrawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (releaseTrap) { releaseTrap(); releaseTrap = null; }
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    openDrawer = null;
  }
  window.afCloseDrawer = closeDrawer;

  function showDrawer(id, trigger) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    if (openDrawer && openDrawer !== drawer) closeDrawer();
    lastTrigger = trigger || document.activeElement;
    drawer.setAttribute('data-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    var overlay = $('[data-af-overlay]');
    if (overlay) overlay.setAttribute('data-open', 'true');
    document.body.classList.add('af-no-scroll');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    openDrawer = drawer;
    releaseTrap = trapFocus(drawer, closeDrawer);
    window.setTimeout(function () {
      var target = drawer.querySelector('[data-af-autofocus]') || drawer.querySelector(FOCUSABLE);
      if (target) target.focus();
    }, RM.matches ? 0 : 60);
  }
  window.afOpenDrawer = showDrawer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-af-drawer-open]');
    if (opener) { e.preventDefault(); showDrawer(opener.getAttribute('data-af-drawer-open'), opener); return; }
    if (e.target.closest('[data-af-drawer-close]') || e.target.closest('[data-af-overlay]')) {
      e.preventDefault(); closeDrawer();
    }
  });

  /* ---------- Akordeon (button + panel, aria-expanded) ------------------ */
  function initAccordions(root) {
    $$('[data-af-accordion]', root || document).forEach(function (acc) {
      if (acc._afInit) return;
      acc._afInit = true;
      var single = acc.getAttribute('data-af-accordion') === 'single';
      $$('[data-af-accordion-trigger]', acc).forEach(function (trigger) {
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!panel) return;
        // Panele domykamy dopiero tutaj — bez JS zostają otwarte i czytelne.
        if (trigger.getAttribute('aria-expanded') !== 'true') panel.hidden = true;
        on(trigger, 'click', function () {
          var expanded = trigger.getAttribute('aria-expanded') === 'true';
          if (single && !expanded) {
            $$('[data-af-accordion-trigger][aria-expanded="true"]', acc).forEach(function (other) {
              other.setAttribute('aria-expanded', 'false');
              var op = document.getElementById(other.getAttribute('aria-controls'));
              if (op) op.hidden = true;
            });
          }
          trigger.setAttribute('aria-expanded', String(!expanded));
          panel.hidden = expanded;
        });
      });
    });
  }

  /* ---------- Ilość ----------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-af-qty]');
    if (!btn) return;
    var wrap = btn.closest('.af-qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = btn.getAttribute('data-af-qty') === 'plus' ? 1 : -1;
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Nawigacja: mega menu -------------------------------------- */
  function initMegaMenu() {
    $$('[data-af-mega]').forEach(function (item) {
      if (item._afInit) return;
      var trigger = $('[data-af-mega-trigger]', item);
      var panel = $('[data-af-mega-panel]', item);
      if (!trigger || !panel) return;
      item._afInit = true;
      var timer;
      function open() { window.clearTimeout(timer); item.setAttribute('data-open', 'true'); trigger.setAttribute('aria-expanded', 'true'); }
      function close() { item.setAttribute('data-open', 'false'); trigger.setAttribute('aria-expanded', 'false'); }
      function delayedClose() { timer = window.setTimeout(close, 120); }
      on(trigger, 'click', function (e) {
        e.preventDefault();
        item.getAttribute('data-open') === 'true' ? close() : open();
      });
      on(item, 'mouseenter', open);
      on(item, 'mouseleave', delayedClose);
      on(item, 'focusin', open);
      on(item, 'focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
      on(item, 'keydown', function (e) { if (e.key === 'Escape') { close(); trigger.focus(); } });
    });
  }

  /* ---------- Predictive search ----------------------------------------- */
  function initPredictive() {
    $$('[data-af-predictive]').forEach(function (wrap) {
      if (wrap._afInit) return;
      var input = $('input[type="search"]', wrap);
      var results = $('[data-af-predictive-results]', wrap);
      if (!input || !results) return;
      wrap._afInit = true;
      var timer, controller;

      // Pole szukania nie jest combobox — nie ustawiamy na nim aria-expanded.
      // Wyniki to region z aria-live, a strzałki przenoszą fokus na linki.
      function clear() { results.innerHTML = ''; results.hidden = true; }

      on(input, 'input', function () {
        var q = input.value.trim();
        window.clearTimeout(timer);
        if (q.length < 2) { clear(); return; }
        timer = window.setTimeout(function () {
          if (controller) controller.abort();
          controller = new AbortController();
          var url = window.Shopify.routes.root + 'search/suggest?q=' + encodeURIComponent(q) +
            '&resources[type]=product,collection,article,query&resources[limit]=6' +
            '&resources[options][unavailable_products]=last&section_id=af-predictive-search';
          results.hidden = false;
          results.setAttribute('aria-busy', 'true');
          fetch(url, { signal: controller.signal })
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var payload = doc.querySelector('[data-af-predictive-results]');
              results.innerHTML = payload ? payload.innerHTML : '';
              results.removeAttribute('aria-busy');
            })
            .catch(function (err) {
              if (err.name === 'AbortError') return;
              results.removeAttribute('aria-busy');
              results.innerHTML = '<p class="af-predictive__label">Nie udało się pobrać podpowiedzi. Naciśnij Enter, aby wyszukać.</p>';
            });
        }, 220);
      });

      on(input, 'keydown', function (e) {
        if (e.key === 'Escape') { clear(); return; }
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        var links = $$('a', results);
        if (!links.length) return;
        e.preventDefault();
        var idx = links.indexOf(document.activeElement);
        idx = e.key === 'ArrowDown' ? Math.min(links.length - 1, idx + 1) : Math.max(0, idx - 1);
        links[idx].focus();
      });

      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) clear(); });
    });
  }

  /* ---------- Section Rendering API --------------------------------------
     Sekcje w szablonach JSON i w grupach nagłówka/stopki mają dynamiczne ID
     (np. `template--123__main`), a nie nazwę pliku. Dlatego każda sekcja,
     którą odświeżamy, wypisuje swoje `section.id` w atrybucie data-*.
     Odwoływanie się do nazwy pliku zwracałoby null i cicho psuło odświeżanie. */
  function afSectionId(selector) {
    var el = $(selector);
    return el ? el.getAttribute('data-af-section-id') : null;
  }

  /* ---------- Koszyk: dodanie przez fetch + odświeżenie drawera --------- */
  function refreshCartUI() {
    var cartId = afSectionId('[data-af-cart-section]');
    var headerId = afSectionId('[data-af-header-section]');
    var ids = [cartId, headerId].filter(Boolean);
    if (!ids.length) return Promise.resolve();

    return fetch(window.Shopify.routes.root + '?sections=' + ids.join(','))
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (sections) {
        var drawerHtml = cartId ? sections[cartId] : null;
        if (drawerHtml) {
          var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
          var fresh = doc.querySelector('[data-af-cart-content]');
          var current = $('[data-af-cart-content]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        }
        var headerHtml = headerId ? sections[headerId] : null;
        if (headerHtml) {
          var hdoc = new DOMParser().parseFromString(headerHtml, 'text/html');
          var freshCount = hdoc.querySelector('[data-af-cart-count]');
          var currentCount = $('[data-af-cart-count]');
          if (freshCount && currentCount) currentCount.outerHTML = freshCount.outerHTML;
          else if (freshCount && !currentCount) {
            var host = $('[data-af-cart-count-host]');
            if (host) host.appendChild(freshCount);
          } else if (!freshCount && currentCount) {
            currentCount.remove();
          }
        }
        initSections();
      });
  }
  window.afRefreshCart = refreshCartUI;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action$="/cart/add"]')) return;
    if (!window.fetch) return; // bez fetch: natywny submit, sklep nadal działa
    e.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button) button.setAttribute('data-loading', 'true');
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (button) button.removeAttribute('data-loading');
        if (!res.ok) {
          announce(res.data.description || 'Nie udało się dodać produktu. Odśwież stronę i spróbuj ponownie.', 'error');
          return;
        }
        return refreshCartUI().then(function () {
          announce('Gotowe — produkt jest w koszyku.', 'success');
          showDrawer('af-cart-drawer', button);
        });
      })
      .catch(function () {
        if (button) button.removeAttribute('data-loading');
        announce('Brak połączenia. Sprawdź internet i spróbuj ponownie.', 'error');
      });
  });

  // Zmiana ilości / usunięcie pozycji w koszyku
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-af-cart-qty]');
    if (!input) return;
    updateCartLine(input.getAttribute('data-af-cart-key'), input.value);
  });
  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-af-cart-remove]');
    if (!remove) return;
    e.preventDefault();
    updateCartLine(remove.getAttribute('data-af-cart-remove'), 0);
  });

  function updateCartLine(key, quantity) {
    var content = $('[data-af-cart-content]');
    if (content) content.setAttribute('aria-busy', 'true');
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: parseInt(quantity, 10) })
    })
      .then(function () { return refreshCartUI(); })
      .then(function () {
        if (content) content.removeAttribute('aria-busy');
        announce(parseInt(quantity, 10) === 0 ? 'Produkt usunięty z koszyka.' : 'Koszyk zaktualizowany.', 'info');
      })
      .catch(function () {
        if (content) content.removeAttribute('aria-busy');
        announce('Nie udało się zaktualizować koszyka.', 'error');
      });
  }

  /* ---------- Galeria produktu ------------------------------------------ */
  function initGallery() {
    $$('[data-af-gallery]').forEach(function (gallery) {
      if (gallery._afInit) return;
      var slides = $$('[data-af-slide]', gallery);
      var thumbs = $$('[data-af-thumb]', gallery);
      var counter = $('[data-af-gallery-counter]', gallery);
      if (!slides.length) return;
      gallery._afInit = true;

      function activate(index) {
        slides.forEach(function (s, i) { s.setAttribute('data-active', String(i === index)); });
        thumbs.forEach(function (t, i) { t.setAttribute('aria-current', String(i === index)); });
        if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
        if (window.innerWidth < 1000) {
          slides[index].scrollIntoView({ behavior: RM.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        }
      }
      thumbs.forEach(function (thumb, i) {
        on(thumb, 'click', function () { activate(i); });
      });
      activate(0);
      gallery._afActivate = activate;
    });
  }

  /* ---------- Warianty --------------------------------------------------- */
  function initVariantPickers() {
    $$('[data-af-variants]').forEach(function (picker) {
      if (picker._afInit) return;
      var dataEl = $('[data-af-variant-data]', picker);
      if (!dataEl) return;
      picker._afInit = true;
      var variants = JSON.parse(dataEl.textContent);
      var form = document.getElementById(picker.getAttribute('data-af-variants'));
      var idInput = form && form.querySelector('input[name="id"]');

      function currentSelection() {
        return $$('input[type="radio"]:checked', picker).map(function (i) { return i.value; });
      }
      function findVariant(selection) {
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selection[i]; });
        });
      }
      on(picker, 'change', function () {
        var selection = currentSelection();
        var variant = findVariant(selection);
        var button = form && form.querySelector('[data-af-add]');
        var priceHost = $('[data-af-price-host]');

        if (!variant) {
          if (button) { button.setAttribute('aria-disabled', 'true'); button.textContent = 'Ten wariant jest niedostępny'; }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (button) {
          if (variant.available) {
            button.removeAttribute('aria-disabled');
            button.removeAttribute('disabled');
            button.textContent = 'Dodaj do koszyka';
          } else {
            button.setAttribute('aria-disabled', 'true');
            button.textContent = 'Powiadom o dostępności';
          }
        }
        // URL i cena odświeżane przez Section Rendering API — bez przeładowania.
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());

        var productSectionId = afSectionId('[data-af-product-section]');
        if (priceHost && productSectionId) {
          priceHost.setAttribute('aria-busy', 'true');
          fetch(url.pathname + '?variant=' + variant.id + '&section_id=' + productSectionId)
            .then(function (r) { return r.ok ? r.text() : null; })
            .then(function (html) {
              priceHost.removeAttribute('aria-busy');
              if (!html) { window.location.href = url.toString(); return; }
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('[data-af-price-host]');
              if (fresh) priceHost.innerHTML = fresh.innerHTML;
              else window.location.href = url.toString();
            })
            .catch(function () {
              // Nigdy nie zostawiamy ceny innego wariantu niż wybrany.
              priceHost.removeAttribute('aria-busy');
              window.location.href = url.toString();
            });
        } else if (priceHost) {
          window.location.href = url.toString();
        }
        var gallery = $('[data-af-gallery]');
        if (gallery && gallery._afActivate && variant.featured_media_position != null) {
          gallery._afActivate(variant.featured_media_position);
        }
      });
    });
  }

  /* ---------- Sticky Add to Cart ---------------------------------------- */
  function initStickyAtc() {
    var sticky = $('[data-af-sticky-atc]');
    var anchor = $('[data-af-atc-anchor]');
    if (!sticky || !anchor || !('IntersectionObserver' in window)) return;
    if (sticky._afInit) return;
    sticky._afInit = true;
    new IntersectionObserver(function (entries) {
      sticky.setAttribute('data-visible', String(!entries[0].isIntersecting));
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(anchor);
  }

  /* ---------- Filtry ----------------------------------------------------- */
  function initFacets() {
    var form = $('[data-af-facets-form]');
    if (!form || form._afInit) return;
    form._afInit = true;
    var resultsHost = $('[data-af-results]');
    var sectionId = form.getAttribute('data-af-section');

    function apply(url, push) {
      if (resultsHost) resultsHost.setAttribute('aria-busy', 'true');
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-af-results]', '[data-af-facets-inner]', '[data-af-active-filters]', '[data-af-result-count]'].forEach(function (sel) {
            var fresh = doc.querySelector(sel);
            var current = $(sel);
            if (fresh && current) current.innerHTML = fresh.innerHTML;
          });
          if (resultsHost) resultsHost.removeAttribute('aria-busy');
          if (push) window.history.pushState({}, '', url);
          initSections();
          var count = $('[data-af-result-count]');
          if (count) announce(count.textContent.trim(), 'info');
        })
        .catch(function () {
          if (resultsHost) resultsHost.removeAttribute('aria-busy');
          window.location.href = url; // twarde przejście zamiast martwego ekranu
        });
    }

    on(form, 'change', function () {
      var params = new URLSearchParams(new FormData(form));
      var clean = new URLSearchParams();
      params.forEach(function (value, key) { if (value !== '') clean.append(key, value); });
      apply(window.location.pathname + '?' + clean.toString(), true);
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-af-facet-remove]');
      if (!link) return;
      e.preventDefault();
      apply(link.getAttribute('href'), true);
    });

    window.addEventListener('popstate', function () { apply(window.location.href, false); });
  }

  /* ---------- Consent banner (Shopify Customer Privacy API) ------------- */
  function initConsent() {
    var banner = $('[data-af-consent]');
    if (!banner || banner._afInit) return;
    banner._afInit = true;
    function hasDecision() {
      try { return window.Shopify.customerPrivacy.shouldShowBanner() === false; } catch (e) { return false; }
    }
    function setConsent(payload) {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(payload, function () { banner.hidden = true; });
      } catch (e) { banner.hidden = true; }
    }
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err) { banner.hidden = true; return; }
      banner.hidden = hasDecision();
    });
    on($('[data-af-consent-accept]', banner), 'click', function () {
      setConsent({ analytics: true, marketing: true, preferences: true, sale_of_data: false });
    });
    on($('[data-af-consent-reject]', banner), 'click', function () {
      setConsent({ analytics: false, marketing: false, preferences: false, sale_of_data: false });
    });
    on($('[data-af-consent-save]', banner), 'click', function () {
      function checked(sel) { var el = $(sel, banner); return !!(el && el.checked); }
      setConsent({
        analytics: checked('[data-af-consent-analytics]'),
        marketing: checked('[data-af-consent-marketing]'),
        preferences: checked('[data-af-consent-preferences]'),
        sale_of_data: false
      });
    });

    // Ponowne otwarcie z linku „Ustawienia prywatności” w stopce.
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-af-consent-open]')) return;
      e.preventDefault();
      banner.hidden = false;
      var settingsTrigger = $('[data-af-accordion-trigger]', banner);
      if (settingsTrigger && settingsTrigger.getAttribute('aria-expanded') !== 'true') settingsTrigger.click();
      banner.scrollIntoView({ behavior: RM.matches ? 'auto' : 'smooth', block: 'nearest' });
      var first = banner.querySelector(FOCUSABLE);
      if (first) first.focus();
    });
  }

  /* ---------- Quiz doboru ------------------------------------------------ */
  function initQuiz() {
    var quiz = $('[data-af-quiz]');
    if (!quiz || quiz._afInit) return;
    quiz._afInit = true;
    var steps = $$('[data-af-quiz-step]', quiz);
    var fill = $('[data-af-quiz-fill]', quiz);
    var label = $('[data-af-quiz-label]', quiz);
    var answers = {};
    var index = 0;

    function render() {
      steps.forEach(function (s, i) { s.hidden = i !== index; });
      if (fill) fill.style.width = ((index / steps.length) * 100) + '%';
      if (label) label.textContent = 'Pytanie ' + Math.min(index + 1, steps.length) + ' z ' + steps.length;
      var heading = steps[index] && steps[index].querySelector('h2, h3');
      if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus(); }
    }
    on(quiz, 'click', function (e) {
      var option = e.target.closest('[data-af-quiz-option]');
      if (option) {
        answers[option.getAttribute('data-af-quiz-key')] = option.getAttribute('data-af-quiz-value');
        $$('[data-af-quiz-option]', steps[index]).forEach(function (o) { o.setAttribute('aria-pressed', String(o === option)); });
        index = Math.min(index + 1, steps.length - 1);
        if (Object.keys(answers).length >= steps.length) { finish(); return; }
        render();
        return;
      }
      if (e.target.closest('[data-af-quiz-back]')) { index = Math.max(0, index - 1); render(); }
    });
    function finish() {
      var target = quiz.getAttribute('data-af-quiz-target') || '/collections/all';
      var params = new URLSearchParams();
      Object.keys(answers).forEach(function (k) { params.append('filter.p.m.alfa.' + k, answers[k]); });
      window.location.href = target + '?' + params.toString();
    }
    render();
  }

  /* ---------- Start ------------------------------------------------------
     initSections() jest idempotentne: każdy komponent inicjalizuje się raz.
     Theme Editor wywołuje je ponownie przy przeładowaniu sekcji, a nowe
     elementy dostają swoje handlery bez dublowania istniejących. */
  function initSections() {
    initAccordions();
    initMegaMenu();
    initPredictive();
    initGallery();
    initVariantPickers();
    initStickyAtc();
    initFacets();
    initConsent();
    initQuiz();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSections);
  else initSections();

  // Theme Editor: sekcje przeładowywane dynamicznie muszą ponownie się zainicjalizować.
  document.addEventListener('shopify:section:load', initSections);
})();
